import {Routes} from '@angular/router';

import {appRoutes} from "@numizmat/constants";

import {HomePageComponent} from "@numizmat/pages/home-page";
import {AdDetailPageComponent} from "@numizmat/pages/ad-detail-page";
import {
  ProfilePageComponent
} from "@numizmat/pages/profile-page";
import {AdListPageComponent} from "@numizmat/pages/ad-list-page";
import {AdFormPageComponent} from "@numizmat/pages/ad-form-page";
import {ContactUsPageComponent} from "@numizmat/pages/contact-us-page";
import {HelpInformationPageComponent} from "@numizmat/pages/help-information-page";
import {TermsConditionsPageComponent} from "@numizmat/pages/terms-conditions-page";
import {PrivacyPolicyPageComponent} from "@numizmat/pages/privacy-policy-page";
import {
  AccountPageComponent,
  LoginComponent,
  RegistrationComponent,
  RegistrationConfirmComponent,
  RegistrationSuccessComponent,
  PasswordRecoveryComponent,
  PasswordRecoveryConfirmComponent,
  PasswordRecoverySuccessComponent,
} from "@numizmat/pages/account-page";
import {
  CanceledPaymentComponent,
  PaymentResponsePageComponent,
  SuccessPaymentComponent
} from "@numizmat/pages/payment-response-page";
import {NotFoundPageComponent} from "@numizmat/pages/not-found-page";
import {AdWizardPageComponent} from "@numizmat/pages/ad-wizard-page";

export const routes: Routes = [
  {
    path: appRoutes.home,
    component: HomePageComponent,
  },
  {
    path: appRoutes.ad + '/:id',
    component: AdDetailPageComponent,
  },
  {
    path: appRoutes.profile + '/:id',
    component: ProfilePageComponent
  },
  {
    path: appRoutes.adList,
    component: AdListPageComponent
  },
  {
    path: appRoutes.adCrate,
    component: AdWizardPageComponent
  },
  {
    path: appRoutes.adUpdate + '/:id',
    component: AdWizardPageComponent
  },
  {
    path: appRoutes.adCrateSimilar + '/:id',
    component: AdWizardPageComponent
  },
  {
    path: appRoutes.contactUs,
    component: ContactUsPageComponent
  },
  {
    path: appRoutes.helpInformation,
    component: HelpInformationPageComponent
  },
  {
    path: appRoutes.termsConditions,
    component: TermsConditionsPageComponent
  },
  {
    path: appRoutes.privacyPolicy,
    component: PrivacyPolicyPageComponent
  },
  {
    path: appRoutes.account,
    component: AccountPageComponent,
    children: [
      {
        path: appRoutes.login,
        component: LoginComponent
      },
      {
        path: appRoutes.registration,
        component: RegistrationComponent
      },
      {
        path: appRoutes.registrationConfirm,
        component: RegistrationConfirmComponent
      },
      {
        path: appRoutes.registrationSuccess,
        component: RegistrationSuccessComponent
      },
      {
        path: appRoutes.passwordRecovery,
        component: PasswordRecoveryComponent
      },
      {
        path: appRoutes.passwordRecoveryConfirm,
        component: PasswordRecoveryConfirmComponent
      },
      {
        path: appRoutes.passwordRecoverySuccess,
        component: PasswordRecoverySuccessComponent
      },
      {
        path: '**',
        redirectTo: appRoutes.login
      }
    ]
  },
  {
    path: appRoutes.paymentResponse,
    component: PaymentResponsePageComponent,
    children: [
      {
        path: appRoutes.successPayment,
        component: SuccessPaymentComponent
      },
      {
        path: appRoutes.canceledPayment,
        component: CanceledPaymentComponent
      }
    ]
  },
  {
    path: appRoutes.notFound,
    component: NotFoundPageComponent
  },
  {
    path: '**',
    redirectTo: appRoutes.home
  }
];
